import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import parseId from '../../services/parseId'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../../store/index'
import { Link } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import {
    Grid,
    Row,
    Col,
    ContainerWithPadding,
    SectionTitle,
    TextFormField,
    NumberFormField,
    TimePickerFormFieldController,
    FormFieldHidable,
    Container,
    FieldFooter,
    IdFormField,
    SelectOptionModel,
    Tooltip,
    SelectFormFieldController,
    Select,
    ToggleFieldController,
    ToggleFormField,
    LabelFormField,
    DataTable,
    DataTableColumnModel,
    DataTableModel,
    DataTableModelCustomAction,
    FilterType,
    PInTableList,
    apiCallWrapperNoDispatch,
    BasicNoBodyResponse,
} from 'traveldesk-ui'
import TimeSlotGroup from '../../models/TimeSlotGroup'
import { nameof } from 'traveldesk-ui'

import DaysOfferedService from '../../services/daysOfferedService'
import { Buttons } from 'traveldesk-ui'
import { actionCreators as pickUpTimesActions } from '../../store/PickUpTimes'
import { LoadingSection } from '../../components/LoadingSection'
import { actionCreators as timeSlotsActions } from '../../store/TimeSlots'
import TimeSlot, { getTimeSlotTimeTypeOptions, TimeSlotTimeType } from '../../models/TimeSlot'
import booleanOptions from '../../valueObjects/booleanOptions'

interface Props extends RouteComponentProps<{ groupId: string, id: string }> { }

const TimeSlotsGroupForm = (props: Props) => {
    const dispatch = useDispatch()
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const pickUpTimesOptions = useSelector((state: ApplicationState) => state.pickUpTimes.options)
    const timeSlotGroup = useSelector((state: ApplicationState) => state.timeSlots.timeSlotGroup)
    const [showDeletedTimeSlots, setShowDeletedTimeSlots] = React.useState<boolean>(false)
    const onDeleteTimeSlot = async (tsg: TimeSlotGroup, ts: TimeSlot) => {
        if (confirm("Are you sure you want to download time slot: " + ts.name)) {
            dispatch(timeSlotsActions.deleteTimeSlot(tsg, ts.id))
        }
    }
    const onRevertTimeSlot = async (tsg: TimeSlotGroup, ts: TimeSlot) => {
        dispatch(timeSlotsActions.revertTimeSlot(tsg, ts.id))
    }
    const daysOptions = React.useMemo(() => {
        return DaysOfferedService.daysNames.slice(1).map((day, index) => ({ label: day, value: index }))
    }, [DaysOfferedService.daysNames])

    React.useEffect(() => {
        if (pickUpTimesOptions.length == 0) {
            dispatch(pickUpTimesActions.requestPickUpTimesOptions())
        }
    }, [])
    const timeSlotsTableData = React.useMemo(() => {
        return showDeletedTimeSlots ? timeSlotGroup?.timeSlots : timeSlotGroup?.timeSlots.filter(x => !x.isDeleted)
    }, [timeSlotGroup, showDeletedTimeSlots])
    const options = React.useMemo(() => {
        return timeSlotGroup?.timeSlots.reduce((res, ts: TimeSlot) => {
            ts.offers.forEach(offer => {
                if (!res.offersOptions.some(o => offer.id == o.value)) {
                    res.offersOptions.push({ value: offer.id, label: `${offer.nameInternal} (#${offer.id})` })
                }
            })
            res.timeSlotsOptions.push({ value: ts.id, label: `${ts.name} (#${ts.id})` })
            return res
        }, { offersOptions: [] as SelectOptionModel[], timeSlotsOptions: [] as SelectOptionModel[] })
    }, [timeSlotGroup])
    React.useEffect(() => {
        const id = parseId(props.match.params.id)
        if (typeof id == undefined) {
            props.history.push('/timeslots')
        }
        dispatch(timeSlotsActions.manageTimeSlotGroup(id || 0))
    }, [props.match.params.id])
    const onRefresh = () => {
        const id = parseId(props.match.params.id)
        dispatch(timeSlotsActions.manageTimeSlotGroup(id || 0))
    }
    React.useEffect(() => {
        reset(timeSlotGroup)
    }, [timeSlotGroup])
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        getValues,
        setValue,
        watch,
        reset,
        setError,
    } = useForm()
    const onSubmit = (data: any) => {
        dispatch(timeSlotsActions.save(data))
    }
    // const getTimeSlotFieldsNames = (index: number) => {
    //     return {
    //         id: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('id')}`,
    //         name: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('name')}`,
    //         daysOffered: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('daysOfferedList')}`,
    //         startTime: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('startTimeDescription')}`,
    //         endTime: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('endTimeDescription')}`,
    //         capacity: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('capacity')}`,
    //         availabilityType: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('type')}`,
    //         cutOffResponseTime: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>(
    //             'cutOffResponseTime',
    //         )}`,
    //         timeType: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('timeType')}`,
    //         interval: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('interval')}`,
    //         duration: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('duration')}`,
    //         pickUpTimeId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('pickUpTimeId')}`,
    //         externalId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalId')}`,
    //         externalPerChildId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalPerChildId')}`,
    //         bookingReferencePrefix: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('bookingReferencePrefix')}`,
    //         externalProviderDiffProductsAdultChild: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalProviderDiffProductsAdultChild')}`,
    //         isExternalId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('isExternalId')}`,
    //         externalIsTicketPerPax: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalIsTicketPerPax')}`,
    //         externalProviderId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalProviderId')}`,
    //         externalProviderCodeType: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalProviderCodeType')}`,
    //         externalProductId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalProductId')}`,
    //         externalProductPerChildId: `${nameof<TimeSlotGroup>('timeSlots')}[${index}].${nameof<TimeSlot>('externalProductPerChildId')}`,

    //     }
    // }
    const timeSlots = watch('timeSlots') as TimeSlot[]
    // const onAddTimeSlot = () => {
    //     if (timeSlotGroup) {
    //         const data = TimeSlotGroup.Create(getValues() as any)
    //         data.timeSlots = (data.timeSlots || []).concat(TimeSlot.Create(new TimeSlot(), timeSlotGroup))
    //         reset(data)
    //     }
    // }
    const initTimeSlotsDataTable = () => {
        const columns = [
            new DataTableColumnModel({
                displayName: "#",
                fieldName: "id",
                width: 40
            }),
            new DataTableColumnModel({
                displayName: Localization.getString('Name'),
                fieldName: 'name',
                filterFieldName: "id",
                filterType: FilterType.MULTISELECT,
                filterOptions: options?.timeSlotsOptions,
                width: 200,
                customRenderer: (ts: TimeSlot) => `${ts.name} (#${ts.id})`,
            }),
            new DataTableColumnModel({
                displayName: Localization.getString('From'),
                fieldName: 'startTimeDescription',
                sortable: true,
                width: 60,
            }),
            new DataTableColumnModel({
                displayName: Localization.getString('To'),
                fieldName: 'endTimeDescription',
                sortable: true,
                width: 60
            }),
            new DataTableColumnModel({
                displayName: Localization.getString('Days offered'),
                fieldName: "daysOffered",
                filterOptions: daysOptions,
                filterType: FilterType.MULTISELECT,
                customFilterFunc: (filterValue: number[], data: TimeSlot[]) => {
                    return filterValue.length > 0
                        ? data.filter((x) => x.daysOffered == 0 || filterValue.some((f) => (f & x.daysOffered) > 0))
                        : data
                },
                customRenderer: (obj: TimeSlot) =>
                    DaysOfferedService.getDaysNames(obj.daysOffered, Localization).join(','),
            }),
            new DataTableColumnModel({
                displayName: "Offers",
                fieldName: "offers",
                filterOptions: options?.offersOptions,
                filterType: FilterType.MULTISELECT,
                customFilterFunc: (filterValue: number[], data: TimeSlot[]) => {
                    return filterValue.length > 0
                        ? data.filter((x) => x.offers.some(offer => filterValue.indexOf(offer.id) >= 0))
                        : data
                },
                width: 100,
                customRenderer: (obj: TimeSlot) => (
                    <React.Fragment>
                        {obj.offers.map(offer => <Link target='_blank' key={offer.id} to={`/tours/${offer.tourId}/${offer.id}`}><PInTableList>{offer.nameInternal}</PInTableList></Link>)}
                    </React.Fragment>
                )
            }),
            new DataTableColumnModel({
                displayName: "Type",
                fieldName: "timeType",
                customRenderer: (obj: TimeSlot) => TimeSlotTimeType[obj.timeType],
                width: 60,
                filterType: FilterType.MULTISELECT,
                filterOptions: getTimeSlotTimeTypeOptions(Localization)
            }),
            new DataTableColumnModel({
                displayName: "Is External",
                fieldName: "isExternalId",
                filterType: FilterType.SELECT,
                filterOptions: booleanOptions,
                customFilterFunc: (filterValue: any, data: TimeSlot[]) => filterValue === 2 ? data.filter(x => !x.isExternalId) : filterValue === 1 ? data.filter(x => x.isExternalId) : data,
                customRenderer: (obj: TimeSlot) => obj.isExternalId ? <>
                    <PInTableList>Ext. Product Id: {obj.externalProductId} {obj.externalId ? `(${obj.externalId})` : ""}</PInTableList>
                    {obj.externalProductPerChildId ? <PInTableList>Ext. Product Child Id: {obj.externalProductPerChildId} {obj.externalPerChildId ? `(${obj.externalPerChildId})` : ""}</PInTableList> : undefined}
                </> : undefined,
                width: 60,
                // filterType: FilterType.MULTISELECT,
                // filterOptions: getTimeSlotTimeTypeOptions(Localization)
            }),
            new DataTableColumnModel({
                displayName: '',
                width: 40,
                customRenderer: (obj: TimeSlot) => (
                    <Link to={{ pathname: `/timeslots/${obj.groupId}/${obj.id}` }}>
                        <i className="fa fa-pencil clickable" />
                    </Link>
                ),
            }),
            new DataTableColumnModel({
                displayName: '',
                width: 40,
                customRenderer: (obj: TimeSlot) => {
                    return obj.isDeleted
                        ? <i className='fa fa-undo clickable' onClick={timeSlotGroup ? () => onRevertTimeSlot(timeSlotGroup, obj) : undefined} />
                        : <i className='fa fa-trash clickable' onClick={timeSlotGroup ? () => onDeleteTimeSlot(timeSlotGroup, obj) : undefined} />
                }
            })

        ]
        return new DataTableModel({
            columns,
            name: Localization.getString('Time Slots'),
            fileName: 'timeslots.xls',
            customActions: [
                new DataTableModelCustomAction(
                    () => { },
                    () => (
                        timeSlotGroup?.id ?? 0 > 0
                            ? <Link to={`/timeslots/${timeSlotGroup?.id}/add`}>
                                <i className="fa fa-plus" />
                            </Link>
                            : <i title='Please save time slots group first' className='fa fa-plus warning' />
                    ),
                ),
                new DataTableModelCustomAction(
                    () => { },
                    () => <i className={`fa fa-trash ${showDeletedTimeSlots ? "active" : "disabled"}`} onClick={() => setShowDeletedTimeSlots(!showDeletedTimeSlots)} />
                )
            ],
            customRowClassFunction: (obj: TimeSlot) => obj.isDeleted ? "deleted" : undefined
        })
    }
    return (
        <ContainerWithPadding>
            {timeSlotGroup ? (
                <Grid>
                    <SectionTitle
                        title={Localization.getString(
                            timeSlotGroup.id
                                ? `${Localization.getString('Edit time slots group')}`
                                : Localization.getString('Add new time slots group'),
                        )}
                    />
                    <Link className="a-back-to-list" to="/timeslots">
                        {Localization.getString('Back to time slots')}
                    </Link>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col type="50">
                                <Controller
                                    name={nameof<TimeSlot>("id")}
                                    defaultValue={timeSlotGroup.id}
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            hidden
                                            value={timeSlotGroup.id}
                                            name="id"
                                            type="number"
                                            onChange={([e]: any) => parseInt(e.target.value, 10)}
                                        />
                                    )}
                                />
                                <TextFormField
                                    label={Localization.getString('Group Name')}
                                    isRequired
                                    error={errors.name ? errors.name.message : ''}
                                    defaultValue={timeSlotGroup.name}
                                    name={nameof<TimeSlotGroup>('name')}
                                    register={register}
                                    options={{ required: Localization.getString('Group name is required') }}
                                />
                                <NumberFormField
                                    name={nameof<TimeSlotGroup>('capacity')}
                                    isRequired
                                    defaultValue={timeSlotGroup.capacity}
                                    label={Localization.getString('Capacity')}
                                    min={1}
                                    register={register}
                                    max={999999}
                                />
                            </Col>
                            <Col type="50">
                                <NumberFormField
                                    name={nameof<TimeSlotGroup>('minimumAdvancedBooking')}
                                    defaultValue={timeSlotGroup.minimumAdvancedBooking}
                                    label={`${Localization.getString(
                                        'Minimum advanced booking',
                                    )}, ${Localization.getString('hours')}`}
                                    min={-23}
                                    register={register}
                                    max={2400}
                                />

                                <SelectFormFieldController
                                    name={nameof<TimeSlotGroup>('pickUpTimeId')}
                                    label={Localization.getString('Pick up time')}
                                    options={pickUpTimesOptions}
                                    control={control}
                                />

                                <ToggleFieldController
                                    control={control}
                                    label={Localization.getString("Independant Time Slots")}
                                    name={nameof<TimeSlotGroup>("isTimeSlotsIndependant")}
                                />
                            </Col>
                        </Row>
                        <Buttons.StickySaveButton>{Localization.getString('Save')}</Buttons.StickySaveButton>
                    </form>
                    <hr />
                    <Container>
                        <h3>{Localization.getString('Time Slots')}:</h3>
                        <DataTable
                            data={timeSlotsTableData || []}
                            fixedHeight={600}
                            dataTable={initTimeSlotsDataTable()}
                            onRefreshData={(onRefresh)}
                        />
                    </Container>
                </Grid>
            ) : (
                <LoadingSection />
            )
            }
        </ContainerWithPadding >
    )
}
export default TimeSlotsGroupForm
